import type { RouteObject } from "react-router-dom";
import { redirect } from "react-router-dom";

import { addSlashes, withCompanyPrefix } from "../route.utils";
import { Spinner } from "@/components/ui/v2/spinner";
import {
  CompanyFileDetails,
  CompanyFiles,
  CompanyFilesAllPage,
  CompanyFilesImagesPage,
  CompanyFilesDocumentsPage,
  CompanyFilesOtherPage,
} from "@/utils/lazyLoadComponents";

export const COMPANY_FILES_DYNAMIC_FILE_ID_KEY = "fileId";

export enum COMPANY_FILES_PATH_SEGMENTS {
  ROOT = "files",
  ALL = "all",
  IMAGES = "images",
  DOCUMENTS = "documents",
  OTHER = "other",
  DETAILS = `:${COMPANY_FILES_DYNAMIC_FILE_ID_KEY}`,
}

export const companyFilesRoutes: RouteObject = {
  path: COMPANY_FILES_PATH_SEGMENTS.ROOT,
  handle: { breadcrumb: "Files" },
  HydrateFallback: Spinner,
  children: [
    // ── Page-level tabs layout: each tab owns its own table ──────────────────
    {
      Component: CompanyFiles,
      handle: { flushContent: true },
      children: [
        {
          index: true,
          loader: () => redirect(COMPANY_FILES_PATHS.ALL),
        },
        {
          path: COMPANY_FILES_PATH_SEGMENTS.ALL,
          handle: { breadcrumb: "All Files" },
          Component: CompanyFilesAllPage,
        },
        {
          path: COMPANY_FILES_PATH_SEGMENTS.IMAGES,
          handle: { breadcrumb: "Images" },
          Component: CompanyFilesImagesPage,
        },
        {
          path: COMPANY_FILES_PATH_SEGMENTS.DOCUMENTS,
          handle: { breadcrumb: "Documents" },
          Component: CompanyFilesDocumentsPage,
        },
        {
          path: COMPANY_FILES_PATH_SEGMENTS.OTHER,
          handle: { breadcrumb: "Other" },
          Component: CompanyFilesOtherPage,
        },
      ],
    },
    {
      path: COMPANY_FILES_PATH_SEGMENTS.DETAILS,
      handle: { breadcrumb: "Details" },
      Component: CompanyFileDetails,
    },
  ],
};

export const COMPANY_FILES_PATHS = Object.freeze({
  ROOT: withCompanyPrefix(addSlashes(COMPANY_FILES_PATH_SEGMENTS.ROOT)),
  ALL: withCompanyPrefix(
    addSlashes(COMPANY_FILES_PATH_SEGMENTS.ROOT, COMPANY_FILES_PATH_SEGMENTS.ALL),
  ),
  IMAGES: withCompanyPrefix(
    addSlashes(
      COMPANY_FILES_PATH_SEGMENTS.ROOT,
      COMPANY_FILES_PATH_SEGMENTS.IMAGES,
    ),
  ),
  DOCUMENTS: withCompanyPrefix(
    addSlashes(
      COMPANY_FILES_PATH_SEGMENTS.ROOT,
      COMPANY_FILES_PATH_SEGMENTS.DOCUMENTS,
    ),
  ),
  OTHER: withCompanyPrefix(
    addSlashes(
      COMPANY_FILES_PATH_SEGMENTS.ROOT,
      COMPANY_FILES_PATH_SEGMENTS.OTHER,
    ),
  ),
  DETAILS: (fileId: string) =>
    withCompanyPrefix(
      addSlashes(
        COMPANY_FILES_PATH_SEGMENTS.ROOT,
        encodeURIComponent(fileId),
      ),
    ),
});
